import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { ShButtonComponent, ShuiModalRef } from '@gbr-monorepo/gbr-shui';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-cancel-application-dialog',
    imports: [TranslateModule, ShButtonComponent],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './cancel-application.component.html'
})
export class CancleSeasonCreationDialogComponent {
    dialogRef = inject<ShuiModalRef<string>>(ShuiModalRef);

    public onClose(result?: string): void {
        this.dialogRef.close(result);
    }
}
